
const PurchaseFirstBlock = () => {

    return(
        <section className="purchase-first-block mt-[80px] mb-[110px]">
            <h1 data-aos="fade-up" className="lg:text-[140px] md:text-[100px] text-[36px] second-text uppercase">Lease to <span className="text-orange">purchase</span></h1>
            <p data-aos="fade-up" className='lg:text-[22px] md:text-[20px] text-[12px] md:w-[736px] sm:w-[60%] w-[80%]  mx-auto text-center mt-[20px] leading-[132%]'>The biggest achievement of 2023 for the company was the start of lease to purchase offers where we have all types of trucks starting from 2019 Volvo, Freightliner and Kenworths up to 2023 ones.</p>
        </section>
    )
}
export default PurchaseFirstBlock;